export const LISTE_REGLE_FACTURATION = {
  title: 'Liste des règles de facturation',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste règles de facturation',
  },
  actions: {
    add: 'Ajouter une règle de facturation',
    search: 'Rechercher',
    edit: 'Modifier',
    delete: 'Supprimer',
    archiver: 'Archiver',
  },
  tab: {
    libelle: 'Libellé',
    codification: 'Code',
    type: 'Type',
  },
  yes: 'Oui',
  no: 'Non',
};

export const ADD_REGLE_FACTURATION = {
  titleAdd: 'Ajouter une règle de facturation',
  titleEdit: 'Modifier la règle de facturation',
  titleDetail: 'Détail de la règle de facturation',
  actions: {
    cancel: 'Annuler',
  },
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste règles de facturation',
    add: 'Ajout règle de facturation',
    edit: 'Modification règle de facturation',
    detail: 'Détail règle de facturation',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
  },
  informationRegleFacturation: {
    informations: 'Information',
    info: 'Information sur la règle de facturation',
    libelle: 'Libellé',
    codification: 'Code',
    type: 'Type',
    infoFacture: 'Règles pour les factures',
    infoRelance: 'Règles pour les relances',
    piedPage: 'Pied de page',
    zoneInfoPaiement: 'Informations pour les paiements',
    zoneInfoDiverse: 'Zone d\'informations diverses',
    relance1: 'Première relance',
    relance2: 'Deuxième relance',
    relance3: 'Troisième relance',
    relance1text: 'Veuillez renseigner les informations de la première relance',
    relance2text: 'Veuillez renseigner les informations de la deuxième relance',
    relance3text: 'Veuillez renseigner les informations de la troisième relance',
    relance1info: 'Informations de la première relance',
    relance2info: 'Informations de la deuxième relance',
    relance3info: 'Informations de la troisième relance',
    texte: 'Texte',
    signataire: 'Signataire',
    fonctionSignataire: 'Fonction du signataire',
    firstRelance: 'Première relance',
    secondRelance: 'Deuxième relance',
    lastRelance: 'Troisième relance',
    infoLogo: 'Le logo des relances et de la facture est à indiquer dans les pièces jointes',
    sizeWidth: 'Taille du logo dans le texte en largeur (px)',
    sizeHeight: 'Taille du logo dans le texte en hauteur (px)',
    baliseAAjouter: 'Balise à ajouter',
  },
  type: {
    direct: 'Direct',
    tresorPublic: 'Trésor public',
    tresorPublicSansEdition: 'Trésor public sans édition',
    tresorPublicSansEditionNiPaiement: 'Trésor public sans édition ni paiement',
  },
  success: {
    add: 'La règle de facturation a été ajoutée avec succès.',
    edit: 'La règle de facturation a été modifiée avec succès.',
  },
  errors: {
    requiredHeightOrWidth: 'Règle sur {name}: La combinaison des champs hauteur et largeur du logo est obligatoire.',
    logoFactureTailleX: 'La largeur du logo de la facture est incorrecte',
    logoFactureTailleY: 'La hauteur du logo de la facture est incorrecte',
    logoRelance1TailleX: 'La largeur du logo de la relance 1 est incorrecte',
    logoRelance1TailleY: 'La hauteur du logo de la relance 1 est incorrecte',
    logoRelance2TailleX: 'La largeur du logo de la relance 2 est incorrecte',
    logoRelance2TailleY: 'La hauteur du logo de la relance 2 est incorrecte',
    logoRelance3TailleX: 'La largeur du logo de la relance 3 est incorrecte',
    logoRelance3TailleY: 'La hauteur du logo de la relance 3 est incorrecte',
  },
  balise: {
    tableauEcheance: 'Tableau des échéances',
    signataire: 'Signataire',
    fonctionSignataire: 'Fonction du signataire',
    dateRelance: 'Date de la relance',
    blocDestinataire: 'Destinataire',
    logo: 'Logo',
    blocCommercial: 'Commercial',
    lieu: 'Lieu',
    compteClient: 'Compte client',
  },
};
